import { render, staticRenderFns } from "./ProjectSegmentationActive.vue?vue&type=template&id=1663e462&"
import script from "./ProjectSegmentationActive.vue?vue&type=script&lang=js&"
export * from "./ProjectSegmentationActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports